import { IServerResponse, getFirstChildNode, IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';
import { BaseResponse } from '@/components/chat/_domain/server/base-response';

class UserSearchResultResponse extends BaseResponse<UserSearchResultResponse> {
  public responses: UserSearchGameResponse[];
  public requestToken: string;

  constructor(messageNode?: IXmlNode) {
    super();
    if (messageNode) {
      this.responses = [];
      this.requestToken = safeCast(messageNode.attributes.token, '');
      if (messageNode.childNodes.response) {
        for (const node of messageNode.childNodes.response) {
          this.responses.push(new UserSearchGameResponse(node));
        }
      }
    }
  }

  protected filter(response: IServerResponse): boolean {
    return /<finduser/g.test(response.Contents);
  }

  protected map(response: IServerResponse): UserSearchResultResponse {
    const node: Nullable<IXmlNode> = getFirstChildNode(response.Contents);
    if (node === null) {
      throw new Error('Failed to map response');
    }

    return new UserSearchResultResponse(node);
  }
}

class UserSearchGameResponse {
  public chatEngineName: string;
  public results: UserSearchRoomResponse[];

  constructor(messageNode: IXmlNode) {
    this.chatEngineName = messageNode.attributes.chatenginename;
    this.results = [];

    for (const node of messageNode.childNodes.user) {
      this.results.push(new UserSearchRoomResponse(node));
    }
  }
}

class UserSearchRoomResponse {
  public roomId: number;
  public username: string;

  constructor(messageNode: IXmlNode) {
    this.roomId = Number(messageNode.attributes.roomid || 0);
    this.username = messageNode.attributes.username;
  }
}

export { UserSearchResultResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/server/user-search-result-response.ts